import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Zeltsprecher.css';
import { host_url } from '../../../App'; // Import host_url
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente
import { MdKeyboardArrowDown } from 'react-icons/md';

function Zeltsprecher() {
  const [page, setPage] = useState(1);
  const [zelte, setZelte] = useState([]);
  const [selectedZelt, setSelectedZelt] = useState("");
  const [kinder, setKinder] = useState([]);
  const [selectedKind, setSelectedKind] = useState("");
  const [tshirtSize, setTshirtSize] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState(null); // Add state for submission status
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${host_url}/zelte`)
      .then(response => response.json())
      .then(data => setZelte(data.filter(zelt => zelt.Zeltsprecher === null))) // Filter zelte
      .catch(error => console.error('Error fetching zelte:', error));
  }, []);

  useEffect(() => {
    if (selectedZelt) {
      fetch(`${host_url}/kinder?zeltId=${selectedZelt}`)
        .then(response => response.json())
        .then(data => setKinder(data))
        .catch(error => console.error('Error fetching kinder:', error));
    } else {
      setKinder([]);
    }
  }, [selectedZelt]);

  const handleNext = () => setPage(page + 1);
  const handleBack = () => setPage(page - 1);
  const handleSubmit = () => {
    fetch(`${host_url}/zelte`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ZeltID: selectedZelt, Zeltsprecher: selectedKind, TshirtSize: tshirtSize }),
    })
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => { throw new Error(text) });
        }
        return response.json();
      })
      .then(() => {
        const einheiten = ["Montag Vormittag", "Dienstag Vormittag", "Mittwoch Vormittag"];
        const requests = einheiten.map(einheit => ({
          KindID: selectedKind,
          EinheitName: einheit,
          JobName: "Politiker*in"
        }));
        return fetch(`${host_url}/zuteilung`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requests),
        });
      })
      .then(() => {
        setSubmissionStatus('success'); // Set submission status to success
      })
      .catch(error => {
        console.error('Error submitting form:', error);
        setSubmissionStatus('error'); // Set submission status to error
      });
  };

  const handleSelectKind = (kindID) => {
    setSelectedKind(kindID);
  };

  return (
    <div>
      <div className="page-header">
        <BackArrow to="/parlament" />
        <h1>Zeltsprecher*in</h1>
      </div>
      <br />
      {submissionStatus === 'success' && (
        <div>
          <h2>Zeltsprecher*in erfolgreich eingetragen!</h2>
          <button onClick={() => navigate(`/home`)}>Zurück zur Startseite</button>
        </div>
      )}
      {submissionStatus === 'error' && (
        <div>
          <h2>Ein Fehler ist aufgetreten. Bitte versuche es erneut.</h2>
          <button className="btn-secondary" onClick={() => setSubmissionStatus(null)}>Zurück</button>
        </div>
      )}
      {submissionStatus === null && (
        <div>
          {page === 1 && (
            <div>
              <div className="dropdown-form">
                <label>
                  Zelt
                  <div className={`dropdown-wrapper ${selectedZelt ? 'filled' : ''}`}>
                    <select onChange={(e) => setSelectedZelt(e.target.value)} value={selectedZelt}>
                      <option value="">Wähle ein Zelt</option>
                      {zelte.map(zelt => (
                        <option key={zelt.ZeltID} value={zelt.ZeltID}>{zelt.Zeltname}</option>
                      ))}
                    </select>
                    <MdKeyboardArrowDown className="dropdown-chevron" />
                  </div>
                </label>
              </div>
              <button onClick={handleNext} disabled={!selectedZelt}>Weiter</button>
            </div>
          )}
          {page === 2 && (
            <div className="dropdown-form">
              <label>
                Zeltsprecher*in
                <div className={`dropdown-wrapper ${selectedKind ? 'filled' : ''}`}>
                  <select value={selectedKind} onChange={(e) => setSelectedKind(e.target.value)}>
                    <option value="">Wähle den/die Zeltsprecher*in</option>
                    {kinder.map(kind => (
                      <option
                        key={kind.KindID}
                        value={kind.KindID}
                        disabled={kind.KindID === zelte.find(z => z.ZeltID === selectedZelt)?.Zeltsprecher}
                      >
                        {kind.Name}
                      </option>
                    ))}
                  </select>
                  <MdKeyboardArrowDown className="dropdown-chevron" />
                </div>
              </label>
              <button onClick={handleNext} disabled={!selectedKind}>Weiter</button>
              <span className="clickable-text" onClick={handleBack} style={{ display: 'inline-block', marginTop: '12px', cursor: 'pointer' }}>Zurück</span>
            </div>
          )}
          {page === 3 && (
            <div>
              <label className="freitext-label">
                T-Shirt-Größe
                <div className={`dropdown-wrapper ${tshirtSize ? 'filled' : ''}`} style={{ marginTop: '8px' }}>
                  <select
                    value={tshirtSize}
                    onChange={(e) => setTshirtSize(e.target.value)}
                  >
                    <option value="">Größe auswählen</option>
                    <optgroup label="Kinderkleidung">
                      <option value="140">140</option>
                      <option value="152">152</option>
                      <option value="164">164</option>
                    </optgroup>
                  </select>
                  <MdKeyboardArrowDown className="dropdown-chevron" />
                </div>
              </label>
              <button onClick={handleSubmit} disabled={!tshirtSize}>Absenden</button>
              <span className="clickable-text" onClick={handleBack} style={{ display: 'inline-block', marginTop: '12px', cursor: 'pointer' }}>Zurück</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Zeltsprecher;
